/**
 * @desc 修改订单地址
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.Response;
export function request(
  params: API.omsFlow.systemOrder.updateAddress.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/systemOrder/updateAddress`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
